module.exports = __webpack_public_path__ + "88c3bdf049c976e6fa1b3ff41c20a821.gif";